<!-- @format -->

<homefield-icon
	name="media-play"
	class="review-play-button hmf-round-radius hmf-display-flex hmf-align-items-center hmf-justify-content-center"
	[ngClass]="{ 'review-play-button-small': !isLarge, 'review-play-button-large': isLarge }"
	[width]="isLarge ? iconSize.large : iconSize.small"
	[height]="isLarge ? iconSize.large : iconSize.small"
	fill="var(--hmf-background-base)"
/>
